import { StudioLayout } from "@/components/studio";

export default function Studio() {
  return <StudioLayout />;
}
